export default "__VITE_ASSET__9402d91e__"